import { required } from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { DocumentMergeFieldsFormValues } from "./merge-fields/DocumentWriterMergeFormDialog.types.ts";

export class DocumentWriterDefaultFormValidator extends Validator<DocumentMergeFieldsFormValues> {
  constructor() {
    super();

    this.forField("patientId", [required()]);
    this.forField("providerId", [required()]);
    this.forField("selectedTemplate", [required()]);
  }
}
